import { render } from "./BillboardModal.vue?vue&type=template&id=4827106c"
import script from "./BillboardModal.vue?vue&type=script&lang=js"
export * from "./BillboardModal.vue?vue&type=script&lang=js"

import "./BillboardModal.vue?vue&type=style&index=0&id=4827106c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__